import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useParams } from "react-router-dom";
import { ButtonLoader1 } from "../../../components/shared/ButtonLoaders";
import useResetPassword from "../../../services/useResetPassword";

const validationSchema = Yup.object({
  password: Yup.string()
    .required("Password is required")
    .max(100, "Limit exceeded"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});

function ResetPassword() {
  const { email, token } = useParams();
  const [password, setPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const { ResetPassword, loading } = useResetPassword();

  const initialValues = {
    password: "",
    confirm_password: "",
  };

  const { values, errors, handleChange, handleSubmit, touched } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      ResetPassword({
        password: values.password,
        email: email,
        token: token,
      });
    },
  });
  return (
    <>
      <div className="w-full min-h-[100vh] flex justify-center items-center">
        <div className="p-5 flex flex-col justify-center items-center md:w-[500px] w-full bg-white shadow-md rounded-lg">
          <Link
            to="/"
            className="flex items-center gap-1 text-[24px] font-extrabold mb-2"
          >
            <img src="/assets/logo/logo.svg" alt="" />
            <h1 className="text-primary">MedTag</h1>
          </Link>
          <form onSubmit={handleSubmit} className="w-full">
            <h1 className="mt-4 font-[700] text-[20px] text-[#333] text-center">
              Reset your password
            </h1>
            <p className="font-[500] text-[15px] text-[#202224] text-center">
              Create a new password to secure your account.
            </p>
            <div className="w-full flex flex-col gap-3 mt-4">
              <div>
                <div className="relative mt-2">
                  <input
                    placeholder="Enter your new password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    type={password ? "text" : "password"}
                    className="w-full h-[40px] px-3 rounded-md border border-[#DEE4ED] outline-none hover:border-primary focus:border-primary"
                  />
                  <div
                    className="h-full absolute top-0 right-2 cursor-pointer flex items-center justify-center text-center"
                    onClick={() => setPassword(!password)}
                  >
                    {password ? <p>Hide</p> : <p>Show</p>}
                  </div>
                </div>
                {errors.password && touched.password && (
                  <p className="text-red-700 text-xs mt-1">{errors.password}</p>
                )}
              </div>
              <div>
                <div className="relative mt-2">
                  <input
                    placeholder="Confirm your new Password"
                    name="confirm_password"
                    value={values.confirm_password}
                    onChange={handleChange}
                    type={confirmPassword ? "text" : "password"}
                    className="w-full h-[40px] px-3 rounded-md border border-[#DEE4ED] outline-none hover:border-primary focus:border-primary"
                  />
                  <div
                    className="h-full absolute top-0 right-2 cursor-pointer flex items-center justify-center text-center"
                    onClick={() => setConfirmPassword(!confirmPassword)}
                  >
                    {confirmPassword ? <p>Hide</p> : <p>Show</p>}
                  </div>
                </div>
                {errors.confirm_password && touched.confirm_password && (
                  <p className="text-red-700 text-xs mt-1">
                    {errors.confirm_password}
                  </p>
                )}
              </div>
            </div>
            <button
              className="bg-primary hover:opacity-80 w-full h-[40px] text-white rounded-[10px] mt-6 flex justify-center items-center"
              type="submit"
              disabled={loading}
            >
              {loading ? <ButtonLoader1 /> : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
